import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Lightbulb, Calendar } from "lucide-react";
import { DATO_SEMANA } from "../data/content";

export default function DatoSemana() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 md:py-16">
      <Link to="/" className="inline-flex items-center gap-2 text-slate-500 hover:text-cyan-700 transition mb-8 text-sm">
        <ArrowLeft size={16} /> Volver al inicio
      </Link>

      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-yellow-50 text-yellow-700 text-sm font-medium mb-4">
          <Lightbulb size={16} /> Dato de la Semana
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-3">
          {DATO_SEMANA.title}
        </h1>
        <p className="text-xl text-slate-600">{DATO_SEMANA.subtitle}</p>
        <div className="inline-flex items-center gap-1.5 mt-4 text-sm text-slate-500">
          <Calendar size={14} /> {DATO_SEMANA.date}
        </div>
      </div>

      <img src={DATO_SEMANA.image} alt={DATO_SEMANA.title} className="w-full h-80 md:h-96 object-cover rounded-2xl shadow-xl mb-10" />

      <div className="prose prose-lg max-w-none space-y-5">
        {DATO_SEMANA.content.map((p, i) => (
          <p key={i} className="text-slate-700 leading-relaxed text-lg">{p}</p>
        ))}
      </div>

      <div className="mt-12 bg-gradient-to-br from-cyan-600 to-teal-700 rounded-2xl p-8 text-white text-center">
        <h3 className="text-2xl font-bold mb-3">¿Necesitas ayuda profesional?</h3>
        <p className="text-cyan-50 mb-5">No estás solo(a). Buscar ayuda es el primer paso de la recuperación.</p>
        <Link to="/contacto" className="inline-block px-6 py-3 rounded-full bg-white text-cyan-700 font-semibold hover:scale-105 transition">
          Agendar consulta confidencial
        </Link>
      </div>
    </div>
  );
}
